import { render, staticRenderFns } from "./TableRecall.vue?vue&type=template&id=20268974&scoped=true"
import script from "./TableRecall.vue?vue&type=script&lang=js"
export * from "./TableRecall.vue?vue&type=script&lang=js"
import style0 from "./TableRecall.vue?vue&type=style&index=0&id=20268974&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20268974",
  null
  
)

export default component.exports